(function($, App, MyModules) {

    App.SliderController = function(sliderClass, ops) {

        var self = this;

        this.sliderPars = function(options, slider) {
            var defaults =  {
                namespace: 'slider-',
                prevText: '',
                nextText: '',
                animation: 'slide',
                manualControls: slider.next('.js-slider-nav').find('li'),

                start: function(sldr) {
                    //sldr.find('.js-loaded').imagesLoaded(function() {
                        $('.slides').addClass('in');
                    //});
                }
            };

            return $.extend({},defaults,options);
        }

        var sliders = $(sliderClass);
        sliders.each(function(){
            
            var slider = $(this);

            slider.flexslider(self.sliderPars(ops, slider));

        });

    }

})(jQuery, App, MyModules);